import { useContext } from 'react';

import dayjs from 'dayjs';

import { UserContext } from 'Context/user';
import { VehicleLookupContext } from 'Context/vehicleLookup';
import { VehicleContext } from 'Context/vehicles';

import { useShowReturningUserHero } from '../../containers/app/homepage/Hooks/useShowReturningUserHero';
import { DAYS_TO_EXPIRE_ENQUIRY } from '../../containers/app/valuations/valuations.constants';
import { useFeatureFlags } from '../hooks';

export const useReturningUser = () => {
  const { userState } = useContext(UserContext);
  const { vehicleState: vehicles } = useContext(VehicleContext);
  const { vehicleLookupState: vehicleLookup } = useContext(VehicleLookupContext);

  const { experimentResult } = useShowReturningUserHero();
  const { showReturningUserHero } = useFeatureFlags();

  const noVehicleToReturnTo = [
    !showReturningUserHero,
    !experimentResult,
    !userState?.id,
    !vehicleLookup?.enquiry?.dpEnquiryId,
    !vehicleLookup?.enquiry?.valuation?.estimate,
    (vehicles.length === 0),
  ].some((v) => v);

  if (noVehicleToReturnTo) {
    return false;
  }

  const enquiryCreatedAt = vehicleLookup?.enquiry?.createdAt;

  // Replicate the logic in platform
  // https://github.com/motorway/motorway-platform/blob/ca608ce1b81bf68226e6e7e432f725c74c68cfe9/app/utilities/expiry.js#L20
  return !(dayjs(enquiryCreatedAt) < dayjs().subtract(DAYS_TO_EXPIRE_ENQUIRY, 'd'));
};
